
import React from "react";
import { BookOpen, ScrollText, GraduationCap } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

const HeroSectionVerseFinder: React.FC = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className="bg-[#34495E] relative min-h-[600px] md:h-[600px] py-0">
      <div className="container mx-auto px-4 h-full flex flex-col justify-between md:block">
        {/* Increased top padding on mobile to prevent header overlap */}
        <div className={`max-w-6xl mx-auto grid md:grid-cols-2 gap-6 h-full ${isMobile ? 'pt-24 pb-0' : ''}`}>
          {/* Text Column */}
          <div className="space-y-3 pt-6 md:pt-40">
            <h1 className="text-4xl md:text-6xl font-playfair font-bold text-heaven-gold mb-2">
              Scripture for Every <span className="text-heaven-gold block md:inline">Moment</span>
            </h1>
            
            <div className="space-y-6 md:space-y-8">
              <p className="text-base md:text-lg text-white text-left">
                Discover Bible verses tailored to your specific situation, complete with 
                theological commentary and practical application steps.
              </p>
              
              <div className="bg-white/5 p-3 rounded-lg border border-white/10">
                <div className="space-y-2 text-left text-white">
                  <div className="flex items-start gap-2">
                    <BookOpen className="h-5 w-5 text-heaven-gold mt-0.5 shrink-0" />
                    <p className="text-sm"><span className="font-medium">Find relevant scriptures</span> for your current situation</p>
                  </div>
                  <div className="flex items-start gap-2">
                    <ScrollText className="h-5 w-5 text-heaven-gold mt-0.5 shrink-0" />
                    <p className="text-sm"><span className="font-medium">Get theological insights</span> from trusted scholars</p>
                  </div>
                  <div className="flex items-start gap-2">
                    <GraduationCap className="h-5 w-5 text-heaven-gold mt-0.5 shrink-0" />
                    <p className="text-sm"><span className="font-medium">Receive practical guidance</span> for applying God's Word</p>
                  </div>
                </div>
              </div>
              
              <div className="grid grid-cols-3 gap-2">
                <div className="bg-white/5 p-2 rounded text-center">
                  <p className="text-xs italic text-white">
                    "Making a decision"
                  </p>
                </div>
                <div className="bg-white/5 p-2 rounded text-center">
                  <p className="text-xs italic text-white">
                    "Feeling anxious"
                  </p>
                </div>
                <div className="bg-white/5 p-2 rounded text-center">
                  <p className="text-xs italic text-white">
                    "Grateful heart"
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Image Column */}
          <div className="relative h-full flex items-end justify-center md:items-end md:justify-center overflow-hidden">
            <img 
              src="https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//herooooooo.png"
              alt="Person connecting with Scripture"
              className="w-[900px] h-full max-h-[600px] object-contain object-bottom"
              loading="eager"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSectionVerseFinder;
